/**
 * Admin — Notifications layout route (4 sub-tabs).
 */

import { createFileRoute, Outlet, Link, useLocation } from '@tanstack/react-router';
import {
  Bell, Megaphone, GitBranch, ScrollText,
} from 'lucide-react';
import { cn } from '@/lib/utils';

export const Route = createFileRoute('/admin/notifications')({
  component: NotificationsLayout,
});

const SUB_TABS = [
  { label: 'Rules',       path: '/admin/notifications',            icon: Bell },
  { label: 'Channels',    path: '/admin/notifications/channels',   icon: Megaphone },
  { label: 'Escalation',  path: '/admin/notifications/escalation', icon: GitBranch },
  { label: 'Delivery Log',path: '/admin/notifications/log',        icon: ScrollText },
];

function NotificationsLayout() {
  const location = useLocation();

  return (
    <div className="flex flex-col h-full">
      <div className="border-b bg-background px-6 shrink-0">
        <nav className="flex items-center gap-1 overflow-x-auto whitespace-nowrap">
          {SUB_TABS.map(t => {
            const Icon = t.icon;
            const isActive = location.pathname === t.path
              || (t.path !== '/admin/notifications' && location.pathname.startsWith(t.path));
            const isExact = location.pathname === '/admin/notifications' || location.pathname === '/admin/notifications/';
            const active = t.path === '/admin/notifications' ? isExact : isActive;
            return (
              <Link
                key={t.path}
                to={t.path as any}
                title={t.label}
                aria-label={t.label}
                className={cn(
                  'inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium border-b-2 transition-colors -mb-px shrink-0 whitespace-nowrap',
                  active
                    ? 'border-primary text-foreground'
                    : 'border-transparent text-muted-foreground hover:text-foreground',
                )}
              >
                <Icon className="h-3.5 w-3.5 shrink-0" />
                <span className="hidden md:inline">{t.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>

      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
